// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyCalendarsList_emptyList__Ykwg0","editBtn":"EmptyCalendarsList_editBtn__pH+Qb"};